module.exports = __webpack_public_path__ + "img/arrowUpDetails.5741369d.svg";